<template>
  <v-app>
    <v-main>
      <TheHeader/>
      <router-view :key="$route.fullPath" />
      <div v-if="isValidRoute" :key="increment">
        <v-container>
          <BannerAdvert/>
        </v-container>
      </div>
    </v-main>
    <TheFooter/>
  </v-app>
</template>

<script>
import TheHeader from './components/TheHeader'
import TheFooter from './components/TheFooter'
import BannerAdvert from './components/BannerAdvert'

export default {
  components: {
    TheHeader,
    TheFooter,
    BannerAdvert
  },
  data () {
    return {
      increment: 0
    }
  },
  computed: {
    isValidRoute () {
      return !['/over18', '/terms-of-service', '/privacy-policy'].includes(this.$route.fullPath) && process.env.VUE_APP_CENSORED !== 'true'
    }
  },
  watch: {
    $route () {
      this.increment++
    }
  }
}
</script>

<style>
.v-menu__content {
  z-index: 9999 !important;
}

@media (max-width: 600px) {
  .container {
    padding: 10px;
  }
}

@media (min-width: 1904px) {
  .container {
    max-width: 1185px;
  }
}
</style>
